////////////////////////////////////////////
//
// General variables
//
////////////////////////////////////////////

const siteUrl = sessionStorage.getItem('siteUrl')

////////////////////////////////////////////
//
// Mobile Nav toggle with ARIA
//
////////////////////////////////////////////

// $(".navbar-toggle").click(function() {
// 	$(this).toggleClass("active");
// 	$("body").toggleClass("navbar-mobile-active");
// 	const expanded = $(this).attr('aria-expanded');
// 	if (expanded == "false") {
// 		$(this).attr("aria-expanded", true);
// 	} else {
// 		$(this).attr("aria-expanded", false);
// 	}
// });

// Navbar Toggler
document.addEventListener('DOMContentLoaded', function () {
  const navbarToggle = document.querySelector('.navbar-toggle')
  const body = document.querySelector('body')

  function navToggle(event) {
    navbarToggle.classList.toggle('active')
    body.classList.toggle('navbar-mobile-active')

    if (navbarToggle.className == 'active') {
      navbarToggle.setAttribute('aria-expanded', false)
    } else {
      navbarToggle.setAttribute('aria-expanded', true)
    }
    event.preventDefault()
  }

  if (navbarToggle != null) {
    navbarToggle.addEventListener('click', navToggle)
  }
})

////////////////////////////////////////////
//
// Logo Resize on scroll
//
////////////////////////////////////////////

window.addEventListener('scroll', function () {
  let scroll = {
    x: window.pageXOffset,
    y: window.pageYOffset,
  }

  let logo = document.querySelector('.nav-logo')
  if (scroll.y >= 25) {
    logo.classList.add('logo-size')
  } else {
    logo.classList.remove('logo-size')
  }
})
